module.exports = __webpack_public_path__ + "static/img/materialflows copy-03.ef01038.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materialflows copy-03.svg
// module id = TFtZ
// module chunks = 1